import { useEffect } from 'react';

import { AuthFooter } from 'components/auth/auth-footer';
import { AuthOptions } from 'components/auth/auth-options';
import { AuthWrapper } from 'components/auth/auth-wrapper';
import { LoginForm } from 'components/auth/login-form';
import { RegisterForm } from 'components/auth/register-form';
import { useFathom, useStorage } from 'contexts';
import { hasAuthCookie } from 'utils';

const AuthRoute = ({ router, session, toast }) => {
	const fathom = useFathom();
	const storage = useStorage();
	const view = ['login', 'register'].includes(String(router.query.view)) ? String(router.query.view) : '';

	// Hooks
	useEffect(() => {
		const destination = router.query.redirect || router.query.next;
		if (!destination) return;
		storage.storeValue('redirect', destination);
		const { redirect, next, ...query } = router.query;
		router.replace({ pathname: '/auth', query }, undefined, { shallow: true });
	}, [router.query.redirect, router.query.next]);
	useEffect(() => {
		if (!session.isAuthenticated()) return;
		toast.showSuccess(200, `Welcome, ${session.user?.firstName}!`);
		router.push(storage.storage?.redirect || '/home');
	}, [session.isAuthenticated()]);

	// Methods
	const onAuth = async data => {
		if (data.status !== 'active') return router.push(`/verify?email=${data.email}`);
		fathom.trackEvent(view === 'register' ? 'Register' : 'Login', data);
		return await session.onAuth(data);
	};

	const onView = nextView => {
		const { view: currentView, ...query } = router.query;
		router.push({ pathname: '/auth', query: nextView ? { ...query, view: nextView } : query }, undefined, {
			shallow: true,
		});
	};

	// Render
	return (
		<div className='space-y-4'>
			{!view && <AuthOptions onAuth={onAuth} onView={onView} />}
			{view === 'login' && <LoginForm onBack={() => onView('')} onNext={onAuth} onView={onView} />}
			{view === 'register' && <RegisterForm onBack={() => onView('')} onNext={onAuth} onView={onView} />}
			<AuthFooter />
		</div>
	);
};

AuthRoute.getLayout = page => <AuthWrapper title='Sign in'>{page}</AuthWrapper>;

export default AuthRoute;
export async function getServerSideProps({ req }) {
	if (hasAuthCookie(req.cookies)) return { redirect: { destination: '/home' } };
	return { props: {} };
}
